import { Stack, Typography } from "@mui/joy";
import EditTaskListButton from "./EditTaskListButton";
import { useRecoilValue } from "recoil";
import { patientAtom } from "recoil/patientAtom";
import { userAtom } from "recoil/userAtom";
import OpenChatButton from "./OpenChatButton";
import CoachWorkflow from "components/sidebar/workflow/CoachWorkflow";
import RiskDetection from "components/sidebar/RiskDetection";
import { isDev } from "config";
import { format, isToday, isTomorrow, isYesterday } from "date-fns";
import { ko } from "date-fns/locale";
import React from "react";
import ExpirationNoticeSection from "components/sidebar/ExpirationNoticeSection";
import { theme } from "../../styles/theme";

export default function CoachMenu() {
  const userState = useRecoilValue(userAtom);
  const patientState = useRecoilValue(patientAtom);

  const isAdmin = userState?.role === "admin";

  const showWorkflow =
    patientState?.isTaskUpdateRequired &&
    !patientState.isRiskCheckRequired &&
    !((patientState.unreadMessageCount || 0) > 0);

  function customFormatRelative(date: Date) {
    let prefix = "";

    if (isToday(date)) {
      prefix = "오늘";
    } else if (isTomorrow(date)) {
      prefix = "내일";
    } else if (isYesterday(date)) {
      prefix = "어제";
    }

    const timeFormat = "a h시 m분"; // 오전/오후 h시 m분 형식
    const formattedTime = format(date, timeFormat, { locale: ko });

    return prefix
      ? `${prefix} ${formattedTime}`
      : format(date, "PPpp", { locale: ko });
  }

  return (
    <Stack spacing={1}>
      <Stack
        height={"60px"}
        direction={"row"}
        alignItems={"center"}
        justifyContent={"space-between"}
      >
        <Typography
          variant={"Body"}
          sx={{
            color: theme.vars.palette.Content.Strong,
            fontWeight: 700,
          }}
        >
          {patientState?.nickname}
        </Typography>
        <Stack
          direction={"row"}
          divider={
            <Typography
              sx={{
                px: 1,
                color: theme.vars.palette.Content.Weak,
                fontWeight: 500,
              }}
              variant={"Footnote"}
            >
              ·
            </Typography>
          }
        >
          <Typography
            variant={"Footnote"}
            sx={{
              color: theme.vars.palette.Content.Weak,
              fontWeight: 500,
            }}
          >
            {`${
              patientState?.plan === "starter"
                ? "스타터"
                : patientState?.plan === "master"
                  ? "마스터"
                  : "챌린저"
            } 플랜`}
          </Typography>
          {isAdmin && patientState?.coachName && (
            <Typography
              variant={"Footnote"}
              sx={{
                color: theme.vars.palette.Content.Weak,
                fontWeight: 500,
              }}
            >
              {patientState?.coachName} 코치
            </Typography>
          )}
        </Stack>
      </Stack>
      <Stack spacing={1}>
        {patientState?.isRiskCheckRequired && <RiskDetection />}
        {patientState?.isExpirationNoticeRequired && (
          <ExpirationNoticeSection />
        )}
        {showWorkflow && <CoachWorkflow />}
        {(isAdmin || isDev) && <EditTaskListButton />}
        {patientState?.isChatAvailable && <OpenChatButton />}
      </Stack>
    </Stack>
  );
}
